export default __webpack_public_path__ + "f8874b737c27189991e03f266aaa5531.svg";